<template>
  <div>
    <v-card flat class="mb-5">
      <v-card-text class="pa-5">
        <v-container>
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="body-1 font-weight-medium">Detail Sekolah</div>
                </v-col>
                <v-col cols="12" md="4">
                  <v-list>
                    <v-list-item class="px-0">
                      <v-list-item-avatar class="mr-3 hidden-md-and-down" size="48">
                        <v-avatar color="secondary" size="65">
                          <v-icon dark size="30">mdi-bank</v-icon>
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content class="py-0 px-1">
                        <div class="secondary--text font-weight-medium" style="font-size: 15px">
                          {{ $getDeepObj(detail, 'sekolah.nama') || '-' }}
                        </div>
                        <div class="body-2">
                          <div>
                            <span class="grey--text text--darken-1" style="font-size: 13px">NPSN:</span>
                            {{ $getDeepObj(detail, 'sekolah.npsn') || '-' }}
                          </div>
                          <div>
                            <span class="grey--text text--darken-1" style="font-size: 13px">Status:</span>
                            {{ +$getDeepObj(detail, 'sekolah.is_negeri') === 1 ? 'Negeri' : 'Swasta' }}
                          </div>
                          <div>
                            <span class="grey--text text--darken-1" style="font-size: 13px">Alamat:</span>
                            {{ $getDeepObj(detail, 'sekolah.m_kota.keterangan') }} - Prov.
                            {{ $getDeepObj(detail, 'sekolah.m_propinsi.keterangan') }}
                          </div>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="3">
                  <v-list>
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0">
                        <span class="grey--text" style="font-size: 13px">
                          Kriteria / Model Pendampingan
                        </span>
                        <div>
                          <v-icon
                            v-if="detail && detail.k_kp_kategori_psp"
                            :color="kategoris[detail.k_kp_kategori_psp]"
                            class="mr-0"
                            size="30"
                          >
                            mdi-numeric-{{ detail.k_kp_kategori_psp }}-circle
                          </v-icon>
                          <span v-else class="orange--text text--darken-1">Belum ditentukan</span>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" md="3">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <span class="grey--text" style="font-size: 13px">Angkatan</span>
                      <div class="subtitle-1 font-weight-medium secondary--text">
                        <v-icon color="blue" class="mr-0" size="30">
                          mdi-numeric-{{ detail && detail.gelombang }}-circle
                        </v-icon>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="2">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <span class="grey--text" style="font-size: 13px">Status</span>
                      <div class="body-2 font-weight-regular">
                        <v-chip :class="[+$getDeepObj(detail, 'is_aktif') === 1 ? 'green' : 'red', 'white--text']">
                          {{ +$getDeepObj(detail, 'is_aktif') === 1 ? 'Pelaksana' : 'Non Aktif' }}
                        </v-chip>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-row no-gutters>
                <v-col cols="12" lg="4">
                  <div class="body-1 font-weight-medium">Kepala Sekolah</div>
                  <v-list :three-line="!!$getDeepObj(detail, 'sk_url')">
                    <v-list-item class="px-0">
                      <v-list-item-avatar class="mr-3 hidden-md-and-down" size="48">
                        <v-avatar color="secondary" size="65">
                          <v-icon dark large>mdi-account</v-icon>
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content class="py-0 px-1">
                        <div class="secondary--text font-weight-medium" style="font-size: 15px">
                          {{ $getDeepObj(detail, 'ptk.nama') }}
                        </div>
                        <div class="body-2">
                          <div>
                            <span class="grey--text text--darken-1" style="font-size: 13px">No. UKG:</span>
                            {{ $getDeepObj(detail, 'ptk.no_ukg') }}
                          </div>
                          <div>
                            <span class="grey--text text--darken-1" style="font-size: 13px">No. Whatsapp:</span>
                            {{ $getDeepObj(detail, 'ptk.no_hp') || '-' }}
                          </div>
                        </div>
                        <div class="px-0 mt-1" v-if="$getDeepObj(detail, 'sk_url')">
                          <v-list-item-content class="py-0">
                            <span class="grey--text text--darken-1" style="font-size: 13px">SK Kepala Sekolah</span>
                            <div class="body-2 font-weight-regular">
                              <span
                                class="font-weight-medium custom-link"
                                @click="onView($getDeepObj(detail, 'sk_url'))"
                              >
                                <v-icon class="mr-1" color="primary" small dark left>
                                  mdi-file-check
                                </v-icon>
                                {{ $getDeepObj(detail, 'sk_nomor') || '-' }}
                              </span>
                              <br />
                              <span>
                                <v-icon class="mr-1" color="primary" small dark left>
                                  mdi-calendar
                                </v-icon>
                                {{ $localDate($normalizeTime($getDeepObj(detail, 'sk_tanggal'))) || '-' }}
                              </span>
                            </div>
                          </v-list-item-content>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" lg="3">
                  <div class="body-1 font-weight-medium">Fasilitator Pendamping</div>
                  <v-list v-if="$isObject(fsp)">
                    <v-list-item class="px-0">
                      <v-list-item-avatar class="mr-3 hidden-md-and-down" size="48">
                        <v-avatar color="secondary" size="65">
                          <v-icon dark large>mdi-account</v-icon>
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content class="py-0 px-1">
                        <div class="secondary--text font-weight-medium" style="font-size: 15px">
                          {{ fsp.nama }}
                        </div>
                        <div class="body-2">
                          <div>
                            <span class="grey--text text--darken-1" style="font-size: 13px">Nomor SIMPKB:</span>
                            {{ fsp.ptk_id }}
                          </div>
                          <div>
                            <span class="grey--text text--darken-1" style="font-size: 13px">No. Whatsapp:</span>
                            {{ pspProfilPa.no_wa || '-' }}
                          </div>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <div v-else class="mt-1">
                    <em class="orange--text">Belum memiliki fasilitator pendamping</em>
                  </div>
                </v-col>
                <v-col cols="12" lg="3">
                  <div class="body-1 font-weight-medium">Koordinator Fasilitator</div>
                  <v-list v-if="$isObject(kfsp)">
                    <v-list-item class="px-0">
                      <v-list-item-avatar class="mr-3 hidden-md-and-down" size="48">
                        <v-avatar color="secondary" size="65">
                          <v-icon dark large>mdi-account</v-icon>
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content class="py-0 px-1">
                        <div class="secondary--text font-weight-medium" style="font-size: 15px">
                          {{ $getDeepObj(kfsp, 'nama') }}
                        </div>
                        <div class="body-2">
                          <div>
                            <span class="grey--text text--darken-1" style="font-size: 13px">Email:</span>
                            {{ $getDeepObj(kfsp, 'email') }}
                          </div>
                          <div>
                            <span class="grey--text text--darken-1" style="font-size: 13px">No. HP:</span>
                            {{ $getDeepObj(kfsp, 'no_hp') }}
                          </div>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <div v-else class="mt-1">
                    <em class="orange--text">Belum memiliki koordinator fasilitator</em>
                  </div>
                </v-col>
                <v-col cols="12" md="2">
                  <div class="body-1 font-weight-medium">Jenjang</div>
                  <div
                    v-if="$getDeepObj(detail, 'sekolah.m_jenjang.keterangan')"
                    class="secondary--text font-weight-medium"
                    style="font-size: 15px"
                  >
                    {{ $getDeepObj(detail, 'sekolah.m_jenjang.keterangan') }}
                  </div>
                  <div v-else class="mt-1">
                    <em class="orange--text">Belum memiliki jenjang</em>
                  </div>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-row no-gutters>
                <v-col cols="12" lg="4">
                  <div class="body-1 font-weight-medium">Pengawas Binaan</div>
                  <v-list three-line>
                    <v-list-item class="px-0">
                      <v-list-item-avatar class="mr-3 hidden-md-and-down" size="48">
                        <v-avatar color="secondary" size="65">
                          <v-icon dark large>mdi-account</v-icon>
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content class="py-0 px-1">
                        <div class="secondary--text font-weight-medium" style="font-size: 15px">
                          {{ $getDeepObj(detail, 'sekolah_binaan.ptk.nama') || '-' }}
                        </div>
                        <div class="body-2">
                          <div>
                            <span class="grey--text text--darken-1" style="font-size: 13px">No. UKG/SIMPKB ID:</span>
                            {{
                              $getDeepObj(detail, 'sekolah_binaan.ptk.no_ukg') ||
                                $getDeepObj(detail, 'sekolah_binaan.ptk.ptk_id') ||
                                '-'
                            }}
                          </div>
                          <div>
                            <span class="grey--text text--darken-1" style="font-size: 13px">NUPTK:</span>
                            {{ $getDeepObj(detail, 'sekolah_binaan.ptk.nuptk') || '-' }}
                          </div>
                          <div>
                            <span class="grey--text text--darken-1" style="font-size: 13px">NIP:</span>
                            {{ $getDeepObj(detail, 'sekolah_binaan.ptk.ptk_info_dapodik.nip') || '-' }}
                          </div>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" lg="3">
                  <div class="body-1 font-weight-medium">Jenjang Lingkup Binaan</div>
                  <v-list>
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0 px-1">
                        <div class="secondary--text font-weight-medium" style="font-size: 15px">
                          <span v-html="jenjangBinaan"></span>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" lg="3">
                  <div class="body-1 font-weight-medium">Jumlah Sekolah Binaan</div>
                  <v-list>
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0 px-1">
                        <div class="subtitle-1 font-weight-medium secondary--text">
                          <v-icon color="blue" class="mr-0" size="30">
                            mdi-numeric-{{ $getDeepObj(detail, 'sekolah_binaan.jml_binaan') }}-circle
                          </v-icon>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card class="mb-5 mx-auto" flat v-if="!preview">
      <v-card-text class="pa-5">
        <v-container>
          <h2 class="title black--text mb-3">Pilih Status Peserta</h2>
          <v-row dense>
            <template v-for="(item, key) in mBtnPilihan">
              <v-col :key="key" cols="12" md="3" v-if="$allow(item.akses)">
                <v-card
                  outlined
                  @click="onSelected(key)"
                  :style="{
                    height: '100%',
                    backgroundColor: pilihan === key ? item.bgcolor : '#F2F2F2',
                    borderColor: pilihan === key ? item.color : '#F2F2F2',
                    color: pilihan === key ? 'black' : '#757575',
                  }"
                >
                  <v-card-text>
                    <v-list-item>
                      <v-list-item-content class="text-center">
                        <v-icon large dark :color="pilihan === key ? item.color : '#757575'">
                          {{ item.icon }}
                        </v-icon>
                        <v-list-item-title class="subtitle-1 font-weight-bold">
                          {{ item.label }}
                        </v-list-item-title>
                        <p class="body-2">
                          {{ item.desc }}
                        </p>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card-text>
                </v-card>
              </v-col>
            </template>
          </v-row>
          <div class="mt-5" v-if="pilihan">
            <base-form-generator :schema="schema" v-model="form" />

            <v-row v-if="pilihan === 'ganti-kasek'">
              <v-col cols="12" md="6">
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-label color="caption"><small>Pilih Kepala Sekolah Pengganti</small></v-label>
                    </v-list-item-title>
                    <v-list-item-subtitle class="link black--text body-2">
                      <v-btn dark color="orange" @click="onOpenSelect('kasek')">
                        <v-icon left>
                          mdi-magnify
                        </v-icon>
                        Pilih Kepala Sekolah
                      </v-btn>
                    </v-list-item-subtitle>

                    <div class="mt-2" v-if="$isObject(selected['kasek'])">
                      <v-list>
                        <v-list-item>
                          <v-list-item-avatar class="mr-3" size="48">
                            <v-avatar color="secondary" size="65">
                              <v-icon dark>mdi-account</v-icon>
                            </v-avatar>
                          </v-list-item-avatar>
                          <v-list-item-content class="py-0 px-1">
                            <div class="secondary--text font-weight-medium subtitle-1" style="line-height: 1">
                              {{ $getDeepObj(selected['kasek'], 'nama') }}
                            </div>
                            <div class="body-2 mt-1">
                              <template>
                                <span class="font-weight-medium">No. UKG: </span>
                                {{ $getDeepObj(selected['kasek'], 'no_ukg') }}
                                <br />
                                <span class="font-weight-medium">Status: </span>
                                {{
                                  $getDeepObj(selected['kasek'], 'ptk_tugases.0.k_tugas') === 2
                                    ? 'Definitif'
                                    : 'PLT (Pelaksana Tugas)'
                                }}
                                <br />
                              </template>
                              <template>
                                <span class="font-weight-medium">
                                  <v-icon
                                    v-if="$getDeepObj(selected['kasek'], 'no_hp')"
                                    class="mr-1"
                                    color="success"
                                    small
                                    dark
                                    left
                                  >
                                    mdi-whatsapp
                                  </v-icon>
                                  {{ $getDeepObj(selected['kasek'], 'no_hp') || '-' }}
                                </span>
                                <br />
                              </template>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card class="mb-5 mx-auto" flat>
      <v-card-text class="pa-0">
        <v-container>
          <v-expansion-panels flat>
            <v-expansion-panel>
              <v-expansion-panel-header class="py-0">
                <h2 class="title black--text mb-3">Riwayat Perubahan Status Peserta</h2>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list v-if="$getDeepObj(detail, 'psp_pelaksana_logs').length">
                  <template v-for="(item, j) in $getDeepObj(detail, 'psp_pelaksana_logs')">
                    <v-list-item class="px-0" :key="j">
                      <v-list-item-content>
                        <v-row no-gutters>
                          <v-col cols="12" md="4">
                            <v-list-item class="px-0">
                              <v-list-item-avatar class="mr-3" size="48">
                                <v-avatar color="secondary" size="65">
                                  <v-icon dark large>mdi-account</v-icon>
                                </v-avatar>
                              </v-list-item-avatar>
                              <v-list-item-content class="py-0 px-1">
                                <span class="grey--text" style="font-size: 13px">
                                  Nama Verifikator
                                </span>
                                <div class="body-2 font-weight-regular">
                                  <div class="secondary--text font-weight-medium subtitle-1" style="line-height: 1">
                                    {{ $getDeepObj(item, 'akun.nama') || '-' }}
                                  </div>
                                  <div class="body-2 mt-1">
                                    <span class="font-weight-medium">Surel: </span>
                                    {{ $getDeepObj(item, 'akun.email') || '-' }}
                                    <br />
                                  </div>
                                </div>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-list-item class="px-0">
                              <v-list-item-content class="py-0">
                                <span class="grey--text" style="font-size: 13px">
                                  Waktu
                                </span>
                                <div class="body-2 font-weight-regular">
                                  {{ $localDate($normalizeTime($getDeepObj(item, 'created_at')), false, true) }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                          <v-col cols="12" md="2">
                            <v-list-item class="px-0">
                              <v-list-item-content class="py-0">
                                <span class="grey--text" style="font-size: 13px">Status</span>
                                <div class="body-2 font-weight-regular">
                                  {{ $getDeepObj(item, 'aksi') }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-list-item class="px-0">
                              <v-list-item-content class="py-0">
                                <span class="grey--text" style="font-size: 13px">Keterangan</span>
                                <div class="body-2">
                                  {{ $getDeepObj(item, 'catatan') }}
                                  <div v-if="$getDeepObj(item, 'data.catatan')" class="mt-1">
                                    <span class="grey--text" style="font-size: 13px">Catatan tambahan:</span>
                                    <div class="body-2">
                                      {{ $getDeepObj(item, 'data.catatan') }}
                                    </div>
                                  </div>
                                </div>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="`div-${j}`" />
                  </template>
                </v-list>
                <span v-else>Belum ada riwayat Perubahan Peserta</span>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-card-text>
    </v-card>
    <popup-selector :simple-paging="true" ref="popup" :title="popup['title']" :fetch="popup['fetch']">
      <template slot-scope="{ row }">
        <td>
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-row no-gutters>
                <v-col cols="12" md="9">
                  <v-list-item class="px-0">
                    <v-list-item-avatar class="mr-3" size="48">
                      <v-avatar color="secondary" size="65">
                        <v-icon dark>mdi-account</v-icon>
                      </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="black--text font-weight-medium subtitle-1" style="line-height: 1">
                        {{ $getDeepObj(row, 'nama') || '-' }}
                      </div>
                      <div class="body-2 mt-1">
                        <span class="font-weight-medium">No. UKG: </span>
                        {{ $getDeepObj(row, 'no_ukg') || '-' }}
                        <br />
                      </div>
                      <div class="body-2">
                        <span class="font-weight-medium">Status: </span>
                        {{
                          +$ptkTugas(row.ptk_tugases, detail.sekolah_id, 'k_tugas') === 2
                            ? 'Definitf'
                            : 'PLT (Pelaksana Tugas)'
                        }}
                        <br />
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="3">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <span class="grey--text" style="font-size: 13px">
                        Status
                      </span>
                      <div class="mt-1">
                        <v-chip color="blue" text-color="white">
                          Bisa Dipilih
                        </v-chip>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list-item-content>
            <v-list-item-action-text>
              <v-radio-group v-model="form.select">
                <v-radio :value="row.ptk_id" @click="onSelect(row)"></v-radio>
              </v-radio-group>
            </v-list-item-action-text>
          </v-list-item>
        </td>
      </template>
    </popup-selector>
  </div>
</template>

<script>
import PopupSelector from '@components/popup/Selector';
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import { mapActions } from 'vuex';
export default {
  name: 'FormStatus',
  components: { PopupSelector, BaseFormGenerator },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    preview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pilihan: null,
      selected: {},
      popup: {},
      form: {},
      M_ALASAN: [
        'Mengundurkan Diri',
        'Meninggal Dunia',
        'Kesehatan Tidak Memungkinkan',
        'Tidak Mendapatkan Persetujuan Atasan',
        'Tidak Mendapat Rekomendasi Keluarga',
        'Ditugaskan Di Instansi Lain',
        'Alasan Lainnya',
      ],
      kategoris: {
        1: 'indigo',
        2: 'blue',
        3: 'cyan',
      },
    };
  },
  computed: {
    pspKpPaSekolah() {
      return this.$getDeepObj(this.detail, 'psp_kp_pa_sekolahs.0') || {};
    },

    pspKpPaPendampingans() {
      return this.$getDeepObj(this.pspKpPaSekolah, 'psp_kp_pa.psp_kp_pa_pendampingans') || [];
    },

    pspProfilPa() {
      const lastPendampingan = Object.values(this.pspKpPaPendampingans).pop() || {};
      return lastPendampingan.psp_profil_pa || {};
    },

    fsp() {
      return this.pspProfilPa.ptk || {};
    },

    kfsp() {
      const koordinators = this.pspProfilPa.psp_kp_pa_koordinator_pas || [];
      return this.$getDeepObj(koordinators[0], 'akun_koordinator') || {};
    },

    mBtnPilihan() {
      return {
        aktif: {
          label: 'Pelaksana',
          desc: 'Sebagai Peserta yang sah dan dapat mengikuti kegiatan PSP',
          icon: 'mdi-bank-check',
          color: '#39C57B',
          bgcolor: '#39C57B1C',
          akses: 'psp-peserta-pelaksana.aktif',
        },
        'ganti-kasek': {
          label: 'Ubah Kepala Sekolah',
          desc: 'Mengubah data Kepala Sekolah dengan yang sesuai',
          icon: 'mdi-account-arrow-right',
          color: '#FF7F2A',
          bgcolor: '#FFF2DC',
          akses: 'psp-peserta-pelaksana.ganti-kasek',
        },
        'non-aktif': {
          label: 'Non Aktif',
          desc: 'Mengeluarkan sekolah dan KS dari daftar peserta PSP',
          icon: 'mdi-bank-remove',
          color: '#FF4A4A',
          bgcolor: '#FFEBEB',
          akses: 'psp-peserta-pelaksana.non-aktif',
        },
      };
    },

    schema() {
      const isAktif = +this.$getDeepObj(this.detail, 'is_aktif') === 1;
      const M_LABEL_ALASAN = {
        aktif: 'Alasan Peserta di Aktifkan',
        'ganti-kasek': 'Alasan Mengubah Kepala Sekolah',
        'non-aktif': 'Alasan Peserta di Non Aktifkan',
      };
      return [
        {
          type: 'VTextarea',
          name: 'alasan',
          label: M_LABEL_ALASAN[this.pilihan],
          labelColor: 'info',
          placeholder: M_LABEL_ALASAN[this.pilihan],
          rows: 1,
          grid: { cols: 12 },
          outlined: true,
          required: isAktif && this.pilihan === 'aktif' ? false : true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VTextField',
          name: 'sk_nomor',
          label: 'Nomor SK Kepala Sekolah' + (this.pilihan === 'ganti-kasek' ? ' Pengganti' : ''),
          hint: 'wajib diisi',
          required: false,
          labelColor: 'info',
          grid: { cols: 12, md: 6 },
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VDatePicker',
          name: 'sk_tanggal',
          label: 'Tanggal SK Kepala Sekolah' + (this.pilihan === 'ganti-kasek' ? ' Pengganti' : ''),
          labelColor: 'info',
          usePrependInnerIcon: 'mdi-calendar-month',
          hint: 'wajib diisi',
          required: false,
          outlined: true,
          singleLine: true,
          hideDetails: true,
          dense: true,
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          type: 'VTextField',
          name: 'sk_url',
          label: 'Tautan Berkas SK Kepala Sekolah' + (this.pilihan === 'ganti-kasek' ? ' Pengganti' : ''),
          hint: 'wajib diisi',
          required: false,
          labelColor: 'info',
          grid: { cols: 12, md: 6 },
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VTextarea',
          name: 'catatan',
          label: 'Catatan Tambahan',
          labelColor: 'info',
          placeholder: 'Catatan Tambahan',
          rows: 1,
          grid: { cols: 12 },
          outlined: true,
          dense: true,
          singleLine: true,
        },
      ];
    },

    jenjangBinaan() {
      const M_JENJANG = {
        1: 'TK/PAUD',
        2: 'SD',
        3: 'SMP',
        4: 'SMA',
        5: 'SMK',
        6: 'SLB',
      };
      let temp = [];
      for (let i = 1; i <= 6; i++) {
        if (+this.$getDeepObj(this.detail, 'sekolah_binaan.ptk.ptk_tugas.is_ps' + i) === 1) temp.push(M_JENJANG[i]);
      }
      return temp.length ? this.$fkata(temp) : '<em class="orange--text">Belum memiliki jenjang</em>';
    },
  },
  methods: {
    ...mapActions('pelaksana', ['fetchActions']),

    reset() {
      this.$set(this, 'pilihan', '');
      this.$set(this, 'form', {});
      this.$set(this, 'selected', {});
      this.$set(this, 'popup', {});
    },

    onHandleClickAppend() {
      this.$refs[`vFileInput`][0].$el.querySelector('input').click();
    },

    getValue() {
      return this.form;
    },

    initForm(value) {
      const sk = ['sk_nomor', 'sk_tanggal', 'sk_url'];
      for (const item of sk) {
        this.$set(this.form, item, this.$getDeepObj(value, item) || '');
      }
    },

    onView(url) {
      window.open(url);
    },

    onSelected(value) {
      // set
      this.$set(this, 'pilihan', value);
      this.$set(this.form, 'pilihan', value);
    },

    onOpenSelect(tipe) {
      this.$set(this.popup, 'title', 'Pilih Kepala Sekolah');
      this.$set(this.popup, 'fetch', this.getListKasek);
      this.$set(this.popup, 'tipe', tipe);

      if (this.$isObject(this.selected[tipe])) this.$set(this.form, 'select', this.selected[tipe]['ptk_id']);

      this.$nextTick(() => {
        this.$refs.popup.open();
      });
    },

    getListKasek({ params }) {
      return this.fetchActions({
        action: 'ptk',
        params: Object.assign({}, params, {
          sekolah_id: this.detail && this.detail.sekolah_id,
        }),
      });
    },

    onSelect(data) {
      const tipe = this.popup['tipe'];
      this.$set(this.selected, tipe, data);
      this.$set(this.form, 'ptk_id', data['ptk_id']);
      this.$refs.popup.close();
    },

    onDelete() {
      this.berkas = {};
    },
  },
  watch: {
    detail: 'initForm',
  },
};
</script>

<style scoped>
.custom-link {
  cursor: pointer;
}
.custom-link:hover {
  text-decoration: underline;
  color: blue;
}
</style>
